import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Renders a preview card for a single URL. The server applies the SSRF guard;
// the card silently disappears if the fetch fails or yields nothing useful.
// referrerPolicy="no-referrer" keeps the user's URL from leaking to the image host.
export default function LinkPreview({ url }) {
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let alive = true;
    setData(null); setFailed(false);
    api.post("/link-preview", { url })
      .then((r) => { if (alive) setData(r.data); })
      .catch(() => { if (alive) setFailed(true); });
    return () => { alive = false; };
  }, [url]);

  if (failed || !data) return null;
  if (!data.title && !data.description && !data.image) return null;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer nofollow"
      data-testid="link-preview"
      className="flex gap-3 border border-line/10 bg-surface hover:border-line/30 transition-colors max-w-md overflow-hidden"
    >
      {data.image && (
        <img
          src={data.image}
          alt=""
          loading="lazy"
          referrerPolicy="no-referrer"
          onError={(e) => { e.currentTarget.style.display = "none"; }}
          className="w-20 h-20 object-cover flex-shrink-0"
        />
      )}
      <div className="py-2 pr-3 min-w-0 flex-1">
        {data.site_name && <p className="label-tiny mb-0.5 truncate">{data.site_name}</p>}
        <p className="text-sm font-semibold text-fg truncate">{data.title}</p>
        {data.description && <p className="text-xs text-fg/60 line-clamp-2 mt-0.5">{data.description}</p>}
      </div>
    </a>
  );
}
